import { useMemo, useEffect, useState, useRef } from "react";
import { Attachment } from "stream-chat-react";
import styled from "styled-components";
import Icon from "@material-ui/core/Icon";

const Container = styled.div`
  display: flex;
  padding: 8px;
`;

const ToggleButton = styled.button`
  border: none;
  border-radius: 100px;
  background: #fff;
  cursor: pointer;
  flex-shrink: 0;
  height: 40px;
  width: 40px;

  span {
    font-family: "Material Icons" !important;
  }
`;

const Data = styled.div`
  padding: 2px 8px 0px 8px;
`;

const AudioTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    font-weight: 600;
    padding-bottom: 4px;
    max-width: 200px;
    text-wrap: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  span {
    cursor: pointer;
    font-family: "Material Icons" !important;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Time = styled.p`
  font-size: 0.8rem;
  flex-shrink: 0;
  padding-right: 4px;
`;

const Progress = styled.div`
  border-radius: 100px;
  width: 200px;
  height: 4px;
  background: black;
`;

const Fill = styled.div`
  border-radius: 100px;
  width: ${(props) => props.progress || 0}%;
  height: 4px;
  background: white;
  z-index: 3;
`;

const formatSeconds = (seconds) => {
  if (seconds) {
    const h = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const m = Math.floor(seconds / 3600 / 60)
      .toString()
      .padStart(2, "0");
    const s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${h}:${m}:${s}`;
  } else {
    return;
  }
};

export const CustomAttachment = (props) => {
  const { title, type, asset_url } = props.attachments[0];
  const audio = useMemo(() => new Audio(asset_url), [asset_url]);
  audio.preload = "none";
  const audioRef = useRef(audio);
  const durationSeconds = audioRef?.current?.duration;
  const [playing, setPlaying] = useState(false);
  // const [loaded, setLoaded] = useState(false);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (playing) {
      audio.play();
      // if (loaded) {
      //   audio.play();
      // } else {
      //   audio.load();
      // }
    } else {
      audio.pause();
    }
  }, [audio, playing]);
  // useEffect(() => {
  //   audio.addEventListener("canplaythrough", () => {
  //     console.log('canplaythrough loaded, set to true')
  //     setLoaded(true);
  //   });
  //   return () => {
  //     audio.removeEventListener("canplaythrough", () => {
  //       setLoaded(true);
  //     });
  //   };
  // }, [audio]);
  useEffect(() => {
    audio.addEventListener("ended", () => {
      setPlaying(false);
      setProgress(0);
    });
    return () => {
      audio.removeEventListener("ended", () => {
        setPlaying(false);
        setProgress(0);
      });
    };
  }, [audio]);
  useEffect(() => {
    const eventRef = audioRef.current;
    audio.addEventListener("timeupdate", () =>
      setProgress(Math.round((eventRef.currentTime / eventRef.duration) * 100))
    );
    return () => {
      audio.addEventListener("timeupdate", () =>
        setProgress(
          Math.round((eventRef.currentTime / eventRef.duration) * 100)
        )
      );
    };
  }, [audio, durationSeconds]);
  useEffect(() => {
    const eventRef = audioRef.current;
    audio.addEventListener("ended", () => {
      setPlaying(false);
      setProgress(0);
    });
    audio.addEventListener("timeupdate", () =>
      setProgress(Math.round((eventRef.currentTime / eventRef.duration) * 100))
    );
    return () => {
      audio.removeEventListener("ended", () => {
        setPlaying(false);
        setProgress(0);
      });
      audio.addEventListener("timeupdate", () =>
        setProgress(
          Math.round((eventRef.currentTime / eventRef.duration) * 100)
        )
      );
    };
  }, [audio, durationSeconds]);
  if (type !== "audio") return <Attachment {...props} />;
  return (
    <Container>
      <ToggleButton onClick={() => setPlaying(!playing)}>
        {playing ? <Icon>pause</Icon> : <Icon>play_arrow</Icon>}
      </ToggleButton>
      <Data>
        <AudioTitle>
          <p>{title}</p>
          <a href={asset_url} target="_blank" rel="noreferrer">
            <Icon>cloud_download</Icon>
          </a>
        </AudioTitle>
        <Wrapper>
          <Time>{formatSeconds(durationSeconds)}</Time>
          <Progress>
            <Fill progress={progress} />
          </Progress>
        </Wrapper>
      </Data>
    </Container>
  );
};
